import { isProduction } from '../environment';

export const MEETBUTTER_APP_URL = isProduction()
  ? 'https://app.butter.us'
  : 'https://app-stage.butter.us';
export const MEETBUTTER_BUTTER_URL = isProduction()
  ? 'https://butter.us'
  : 'https://stage.butter.us';

export const MEETBUTTER_ROOM_PAGE = '/r';

export const BUTTER_LANDING_URL = `/`;
export const MEETBUTTER_DASHBOARD_URL = `/dashboard`;
export const BUTTER_FEATURES_URL = '/features';
export const BUTTER_DOWNLOAD_URL = '/download';
export const BUTTER_AUTH_URL = `${MEETBUTTER_APP_URL}/auth`;
export const BUTTER_SIGN_UP_URL = `${BUTTER_AUTH_URL}?auth=signup`;
export const MEETBUTTER_AUTH_SUCCESS_URL = `/auth/success`;
export const MEETBUTTER_AUTH_GOOGLE_REDIRECT_URL = `/auth/google`;
export const MEETBUTTER_AUTH_RESET_PASSWORD_URL = `/auth/reset-pass`;

export const MEETBUTTER_ROOM_URL = `/r`;

export const MEETBUTTER_ROOM_SETUP = `/setup`;
export const MEETBUTTER_ROOM_SESSION_PAGE = `/session`;

export const MEETBUTTER_ONBOARDING_URL = `/onboarding`;
export const MEETBUTTER_PRICING_URL = `/pricing`;
export const MEETBUTTER_ROOM_FEEDBACK_SUFFIX = `feedback`;
export const MEETBUTTER_ROOM_INACTIVE_SUFFIX = `inactive`;
export const MEETBUTTER_ROOM_PREVIEW_SUFFIX = `welcome`;

export const MEETBUTTER_FEEDBACK_FORM = 'https://forms.gle/px8LnTt4BkxUgGRt9';

export const MEETBUTTER_HOSTNAMES = {
  prod: 'https://butter.us',
  stage: 'https://stage.butter.us',
  local: 'http://dev-local.butter.us:3000',
};

export const MEETBUTTER_FACEBOOK_LINK = 'https://www.facebook.com/butterushq';
export const MEETBUTTER_TWITTER_LINK = 'https://twitter.com/butter_hq';
export const MEETBUTTER_LINKEDIN_LINK =
  'https://www.linkedin.com/company/meetbutter/';

export const BUTTER_CAREERS_URL = 'https://careers.butter.us';
export const BUTTER_BLOG_URL = 'https://blog.butter.us';
export const MEETBUTTER_HELP_PAGES = 'https://help.butter.us';
export const MEETBUTTER_PRIVACY_POLICY = 'https://help.butter.us/privacy';
export const MEETBUTTER_TERMS = 'https://help.butter.us/terms';
export const MEETBUTTER_GDPR = 'https://help.butter.us/gdpr';
export const MEETBUTTER_SECURITY = 'https://help.butter.us/security';

export const MEETBUTTER_POLLS = 'https://help.butter.us/polls';
export const MEETBUTTER_AGENDA = 'https://help.butter.us/set-agenda';
export const MEETBUTTER_TIMER = 'https://help.butter.us/timer';

export const CALENDLY_BOOK_A_DEMO =
  'https://calendly.com/butter_hq/butterorientation';

export const GOOGLE_CALENDAR_LINK = 'https://www.google.com/calendar/event';

export const ROOM_RECORDING_S3_URL = isProduction()
  ? 'https://meetbutter-room-recordings.s3.eu-west-3.amazonaws.com'
  : 'https://meetbutter-room-recordings-stage.s3.us-east-2.amazonaws.com';

export const ROOM_FILES_S3_URL = isProduction()
  ? 'https://meetbutter-room-files.s3.eu-west-3.amazonaws.com'
  : 'https://meetbutter-room-files-stage.s3.us-east-2.amazonaws.com';
